import React from 'react';
import Helmet from 'react-helmet';

import SiteLogo from './assets/logo.png';

export default function MetaTags() {
  return (
    <Helmet defer={false}>
      <meta property="og:title" content="Mp3Caprice - High Quality Music Downloads" />
      <meta
        property="og:description"
        content="Mp3Caprice offers a big variety of mp3 music in different styles and genres. Discover, buy and download high quality tunes for reasonable prices!"
      />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`https://mp3caprice.com${SiteLogo}`} />
      <meta property="og:url" content="http://mp3caprice.com" />
      <meta property="og:site_name" content="Mp3Caprice.com" />
      <meta property="fb:admins" content="100001529135271" />
      <meta property="fb:app_id" content="1488350481418079" />
    </Helmet>
  );
}
